import { browserInstance as browser } from '@/utils/browser';
import {
  isIosReg,
  isAndroidReg,
  getIosVersionReg,
  getAndroidVersionReg,
  addPointToVersionReg,
  VERSION_CONNECT,
  IOS,
  IOS_IN_USE_AGENT,
} from './constants';
import { mktBridgeCallHandler } from './instantLoaded/toolsWithoutDeps';

export const transformIosString = (str: string) => {
  let resultVersion = str.replace(IOS_IN_USE_AGENT, IOS);
  resultVersion = resultVersion.replace(/_/g, VERSION_CONNECT);
  return resultVersion;
};

export const addPointToVersion = (version: string) => {
  return version.replace(addPointToVersionReg, VERSION_CONNECT);
};

export const getPhoneAndAppVersion = async () => {
  const checkVersion = await mktBridgeCallHandler('checkVersion').catch(() => {});
  const { appver } = checkVersion as any;

  const { userAgent } = navigator;

  let phoneVersion = '';

  const isIos = isIosReg.test(userAgent);
  const isAndroid = isAndroidReg.test(userAgent);

  if (isIos) {
    const match = userAgent.match(getIosVersionReg);
    phoneVersion = match ? transformIosString(match[0]) : '';
  }

  if (isAndroid) {
    const match = userAgent.match(getAndroidVersionReg);
    phoneVersion = match ? match[0] : '';
  }

  const shopeeAppVersion = `${phoneVersion}, ${addPointToVersion(String(appver))}`;

  return shopeeAppVersion;
};

export const getLocation = async () => {
  const { latitude, longitude } = await mktBridgeCallHandler('getLocation').catch(() => {}) as any;
  return [latitude, longitude].toString();
};

export const getPlatform = () => {
  if (browser.android) {
    return `Android ${browser.osVersion}`;
  }

  if (browser.ios) {
    return `iOS ${browser.osVersion}`;
  }

  if (browser.pc) {
    return `PC ${browser.osVersion}`;
  }
};
